import BrandFreeAreaService from '@/services/free-area/brand-free-area'
import HostFreeAreaService from '@/services/free-area/host-free-area'

const freeAreaPaths = [
  'CartFreeArea1',
  'CartFreeArea2',
  'CartFreeArea3',
  'novelty_endpage',
]
class CartFreeAreaForBrandService extends BrandFreeAreaService {
  protected readonly freeAreaPaths = freeAreaPaths
}
class CartFreeAreaForHostService extends HostFreeAreaService {
  protected readonly freeAreaPaths = freeAreaPaths
}
export default class CartFreeAreaService {
  static readonly forBrand = CartFreeAreaForBrandService
  static readonly forHost = CartFreeAreaForHostService
}
